import React from "react";
import Image from "gatsby-image";
import { useTeamPhotos } from "shared/Hooks/About/Team";
import { SocialmonsterNewImage } from "./SocialmonsterNewImage";

// icons todo
import VueIcon from "assets/images/technologies/vue.svg";

export const SocialmonsterNewData = () => {
  const images = SocialmonsterNewImage();
  const team_images = useTeamPhotos();

  return {
    color: "#2EB9FF",
    title: "Social Monster 2",
    seo:
      "Przeprowadzenie redesignu własnej marki jest wyzwaniem, ale nic nie cieszy bardziej niż ciągły rozwój!",
    slug: "social-monster-new",
    hero: {
      title: "Przejście do trzeciego wymiaru.",
      color: "#2EB9FF",
      background: (
        <Image
          alt=""
          objectPosition={"center"}
          objectFit={"cover"}
          fluid={images.hero.childImageSharp.fluid}
        />
      ),
      detail: (
        <Image
          alt=""
          objectPosition={"center"}
          objectFit={"contain"}
          fluid={images.detail.childImageSharp.fluid}
        />
      ),
    },
    list: {
      detail: (
        <Image
          alt=""
          objectPosition={"center"}
          objectFit={"contain"}
          fluid={images.list_detail.childImageSharp.fluid}
        />
      ),
      background: (
                <Image
                  alt=""
                  objectPosition={"center"}
                  objectFit={"contain"}
                  fluid={images.list_bg.childImageSharp.fluid}
                />
              ),
    },
    what_we_did: {
      title: "Autorskie rysunki, które wypromują Twoją markę",
      technologies: [
        "Strona WWW",
        "UX Workshops",
        "Rebranding marki",
        "Brand heros",
      ],
      text:
        "Przeprowadzenie re-designu własnej marki jest wyzwaniem, ale nic nie cieszy bardziej niż ciągły rozwój! Dlatego zdecydowaliśmy się na zmianę brandingu własnej marki Social Monster, której działalność skupia się na obsłudze i kampaniach w mediach społecznościowych. Zmiana jej wizerunku przyczyni się do zwiększenia popularności i wyróżnienie się wśród konkurencji. Potworki, które są brand heroes marki, reprezentują portale społecznościowe - Facebook, Instagram, LinkedIn.",
      list: [
        "Zrealizowaliśmy kompleksowy redesign marki",
        "Wykonaliśmy modele 3D brand heroes",
        "Opracowaliśmy schemat działań social media",
      ],
    },
    full_images: {
      first: {
        image: (
          <Image
            alt=""
            objectPosition={"center"}
            objectFit={"contain"}
            fluid={images.soc_1f.childImageSharp.fluid}
          />
        ),
      },
      second: {
        image: (
          <Image
            alt=""
            objectPosition={"center"}
            objectFit={"contain"}
            fluid={images.soc_2f.childImageSharp.fluid}
          />
        ),
      },
      third: {
        image: (
          <Image
            alt=""
            objectPosition={"center"}
            objectFit={"contain"}
            fluid={images.soc_3f.childImageSharp.fluid}
          />
        ),
      },
      fourth: {
        image: (
          <Image
            alt=""
            objectPosition={"center"}
            objectFit={"contain"}
            fluid={images.soc_4f.childImageSharp.fluid}
          />
        ),
      },
      fifth: {
        image: (
          <Image
            alt=""
            objectPosition={"center"}
            objectFit={"contain"}
            fluid={images.soc_5f.childImageSharp.fluid}
          />
        ),
      },
      sixth: {
        image: (
          <Image
            alt=""
            objectPosition={"center"}
            objectFit={"contain"}
            fluid={images.soc_6f.childImageSharp.fluid}
          />
        ),
      },
      seventh: {
        image: (
          <Image
            alt=""
            objectPosition={"center"}
            objectFit={"contain"}
            i
            fluid={images.soc_7f.childImageSharp.fluid}
          />
        ),
      },
      eighth: {
        image: (
          <Image
            alt=""
            objectPosition={"center"}
            objectFit={"contain"}
            fluid={images.soc_8f.childImageSharp.fluid}
          />
        ),
      },
      ninth: {
        image: (
          <Image
            alt=""
            objectPosition={"center"}
            objectFit={"contain"}
            fluid={images.soc_9f.childImageSharp.fluid}
          />
        ),
      },

      tenth: {
        image: (
          <Image
            alt=""
            objectPosition={"center"}
            objectFit={"contain"}
            fluid={images.soc_10f.childImageSharp.fluid}
          />
        ),
      },

      eleventh: {
        image: (
          <Image
            alt=""
            objectPosition={"center"}
            objectFit={"contain"}
            fluid={images.soc_11f.childImageSharp.fluid}
          />
        ),
      },
      twelfth: {
        image: (
          <Image
            alt=""
            objectPosition={"center"}
            objectFit={"contain"}
            fluid={images.soc_12f.childImageSharp.fluid}
          />
        ),
      },
      thirteenth: {
        image: (
          <Image
            alt=""
            objectPosition={"center"}
            objectFit={"contain"}
            fluid={images.soc_13f.childImageSharp.fluid}
          />
        ),
      },
      fourteenth: {
        image: (
          <Image
            alt=""
            objectPosition={"center"}
            objectFit={"contain"}
            fluid={images.soc_14f.childImageSharp.fluid}
          />
        ),
      },
      fifteenth: {
        image: (
          <Image
            alt=""
            objectPosition={"center"}
            objectFit={"contain"}
            fluid={images.soc_15f.childImageSharp.fluid}
          />
        ),
      },
      sixteenth: {
        image: (
          <Image
            alt=""
            objectPosition={"center"}
            objectFit={"contain"}
            fluid={images.soc_16f.childImageSharp.fluid}
          />
        ),
      },
      seventeenth: {
        image: (
          <Image
            alt=""
            objectPosition={"center"}
            objectFit={"contain"}
            fluid={images.soc_17f.childImageSharp.fluid}
          />
        ),
      },
      eighteenth: {
        image: (
          <Image
            alt=""
            objectPosition={"center"}
            objectFit={"contain"}
            fluid={images.soc_18f.childImageSharp.fluid}
          />
        ),
      },
      nineteenth: {
        image: (
          <Image
            alt=""
            objectPosition={"center"}
            objectFit={"contain"}
            fluid={images.soc_19f.childImageSharp.fluid}
          />
        ),
      },
      twentyth: {
        image: (
          <Image
            alt=""
            objectPosition={"center"}
            objectFit={"contain"}
            fluid={images.soc_20f.childImageSharp.fluid}
          />
        ),
      },
      twentyFirst: {
        image: (
          <Image
            alt=""
            objectPosition={"center"}
            objectFit={"contain"}
            fluid={images.soc_21f.childImageSharp.fluid}
          />
        ),
      },
      twentySecond: {
        image: (
          <Image
            alt=""
            objectPosition={"center"}
            objectFit={"contain"}
            fluid={images.soc_22f.childImageSharp.fluid}
          />
        ),
      },
    },
    text_boxes: {
      first: {
        title: "Innowacyjny wygląd uroczych potworków",
        text: (
          <>
            Styl marki został zmieniony na bardziej wyrazisty, dzięki czemu nowo
            wykonane brand heroes zapadają w pamięć na dłużej i wzbudzają
            pozytywne skojarzenia. Kolorystyka potworków została oparta o barwy
            każdego z portali społecznościowych, które reprezentują.
          </>
        ),
      },
      second: {
        title: "Media społecznościowe w strasznej odsłonie",
        text:
          "Zadaniem socialowych potworów jest wzbudzenie pozytywnych skojarzeń, pozostanie na długo w pamięci i zachęcenie do współpracy. Dzięki wykorzystaniu technologi 3D w projektowaniu grafik Monstery wyglądają nowocześnie i profesjonalnie. ",
      },
      third: {
        title: "Potwornie intuicyjna i szybka strona www",
        text:
          "Ostatnim etapem prac podczas projektu było stworzenie strony internetowej. Jest ona zaprojektowana zgodnie z najnowszymi technologiami i przy użyciu innowacyjnych rozwiązań. Dzięki temu korzystanie z niej jest szybkie i intuicyjne. Strona internetowa jest w pełni responsywna.",
      },
    },
    technologies: {
      title: "Przykładowy dłuższy nagłówek dotyczący technologii",
      text: (
        <>
          Współpracę z agencją InteractiveVision wysoko cenimy za zaangażowanie,
          elastyczność oraz kompleksowość usług. Zawsze mogliśmy liczyć na
          profesjonalne doradztwo w zakresie planowanych działań oraz
          kreatywność.
          <br />
          <br />
          Dotychczasowa współpraca z tą firmą pozwala nam na rekomendowanie jej
          usług innym.
        </>
      ),
      icons: [
        { title: "Vue", icon: VueIcon },
        { title: "Vue", icon: VueIcon },
        { title: "Vue", icon: VueIcon },
        { title: "Vue", icon: VueIcon },
        { title: "Vue", icon: VueIcon },
        { title: "Vue", icon: VueIcon },
        { title: "Vue", icon: VueIcon },
      ],
    },
    marketing: {
      counts: [
        {
          count: "20%",
          title: "Zwiększona konwersja",
        },
        {
          count: 2000,
          title: "Polubień w 1 miesiąc",
        },
        {
          count: "53%",
          title: "zwiększona sprzedaż",
        },
      ],
      team: [
        {
          name: "Patrycja Bilska",
          position: "Project Manager",
          image: (
            <Image alt="" fluid={team_images.Patrycja.childImageSharp.fluid} />
          ),
        },
        {
          name: "Rafał Skórka",
          position: "Frontend Developer",
          image: (
            <Image alt="" fluid={team_images.Rafal.childImageSharp.fluid} />
          ),
        },
        {
          name: "Patryk Białas",
          position: "Graphic designer",
          image: (
            <Image alt="" fluid={team_images.Patryk.childImageSharp.fluid} />
          ),
        },
        {
          name: "Rafał Krawiec",
          position: "Backend Developer",
          image: (
            <Image alt="" fluid={team_images.Krawczyk.childImageSharp.fluid} />
          ),
        },
        {
          name: "Jakub Żmuda",
          position: "Marketing Specialist",
          image: (
            <Image alt="" fluid={team_images.Kuba.childImageSharp.fluid} />
          ),
        },
        {
          name: "Jakub Furman",
          position: "Sales Manager",
          image: (
            <Image alt="" fluid={team_images.Furman.childImageSharp.fluid} />
          ),
        },
      ],
    },
  };
};
